import React from 'react';
import { DRAWER_PAYMENT_TYPES } from './constants';
import MilestoneFooterInfo from './MilestoneFooterInfo';
import SubscriptionFooterInfo from './SubscriptionFooterInfo';

export const FOOTER_CONFIG = {
    [DRAWER_PAYMENT_TYPES.MILESTONE_PAYMENT]: {
        FooterInfo: () => (<MilestoneFooterInfo/>)
    },
    [DRAWER_PAYMENT_TYPES.SUBSCRIPTION_PAYMENT]: {
        FooterInfo: () => (<SubscriptionFooterInfo/>)
    }
};
